import {
	Component,
	ChangeDetectionStrategy,
	ViewEncapsulation,
	HostBinding,
	ChangeDetectorRef
} from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';

import { OrderService } from '../../../order/services/order.service';
import { FavoriteOrders } from '../../../order/models/favorite-orders';
import { Order } from '../../../order/models/order';

@Component({
	selector: 'copo-favorite-orders-cell',
	templateUrl: './favorite-orders-cell.component.html',
	styleUrl: './favorite-orders-cell.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, MatButtonModule, MatIconModule]
})
export class FavoriteOrdersCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;

	orderData?: Order;
	saveFavoriteOrdersSubscription?: Subscription;
	deleteFavoriteOrdersSubscription?: Subscription;
	isDisabled = false;

	constructor(
		readonly changeDetectorRef: ChangeDetectorRef,
		private readonly orderService: OrderService
	) {}

	agInit(params: ICellRendererParams<Order, unknown>) {
		this.orderData = params.data;
		this.changeDetectorRef.markForCheck();
	}

	refresh(params: ICellRendererParams<Order, unknown>) {
		this.orderData = params.data;
		this.changeDetectorRef.markForCheck();
		return true;
	}

	destroy() {
		if (this.saveFavoriteOrdersSubscription) {
			this.saveFavoriteOrdersSubscription.unsubscribe();
		}

		if (this.deleteFavoriteOrdersSubscription) {
			this.deleteFavoriteOrdersSubscription.unsubscribe();
		}
	}

	deleteFavoriteOrder() {
		if (!this.orderData || !this.orderData.isFavorite || !this.orderData.favorite?.id) {
			return;
		}

		this.isDisabled = true;

		this.deleteFavoriteOrdersSubscription = this.orderService.deleteFavoriteOrders(this.orderData.favorite.id)
			.subscribe({
				next: () => {
					if (!this.orderData) {
						return;
					}

					this.orderData.isFavorite = false;

					this.isDisabled = false;
					this.changeDetectorRef.detectChanges();
				},
				error: (error: unknown) => {
					console.error(error);
					this.isDisabled = false;
				}
			});
	}

	saveFavoriteOrder() {
		if (!this.orderData) {
			return;
		}

		this.isDisabled = true;

		const obj: FavoriteOrders = {
			supplierOrderReference: this.orderData.supplierOrderNumber,
			supplierOrderItem: this.orderData.supplierOrderItemNumber
		};

		this.saveFavoriteOrdersSubscription = this.orderService.saveFavoriteOrders(obj)
			.subscribe({
				next: res => {
					if (!this.orderData) {
						return;
					}

					this.orderData.favorite = {
						id: res.id,
						supplierOrderReference: res.supplierOrderReference,
						supplierOrderItem: res.supplierOrderItem
					};

					this.orderData.isFavorite = true;

					this.isDisabled = false;
					this.changeDetectorRef.detectChanges();
				},
				error: (error: unknown) => {
					console.error(error);
					this.isDisabled = false;
				}
			});
	}
}
